<template>
  <div
    style="
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
    "
  >
    <div
      style="
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: rgba(128, 128, 128, 0.8);
        border-radius: 8px;
      "
    >
      <div>
        <v-btn
          :disabled="isAction"
          @click.stop="onAccept"
          dark
          depressed
          color="primary"
          style="
            border-radius: 16px 16px 16px 0;
            min-width: 100px;
            text-transform: none;
            font-weight: 500;
          "
        >
          {{ $t('accept') }}
        </v-btn>
      </div>
      <div style="margin-top: 8px">
        <v-btn
          :disabled="isAction"
          @click.stop="onDecline"
          outlined
          style="
            border-radius: 16px 0 16px 16px;
            min-width: 100px;
            text-transform: none;
            background-color: white;
            font-weight: 500;
            border-width: 2px;
          "
        >
          {{ $t('decline') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import apiSsoService from '@/services/apiSsoService'
import cookieService from '@/services/cookieService'

export default {
  name: 'VerifyBusinessAction',
  props: {
    channelId: {
      type: [String],
      default: ''
    }
  },
  data() {
    return {
      isAction: false
    }
  },
  methods: {
    async onAccept() {
      this.isAction = true
      try {
        const token = cookieService.getCookie('user_token') || ''
        const profileAccount = JSON.parse(
          localStorage.getItem('profile_account') || '{}'
        )
        const login = profileAccount?.email || profileAccount?.username || ''

        const res = await apiSsoService.post('/api/channel/verify-email', {
          code: token,
          login,
          channel: this.channelId
        })

        if (res && res.data && res.data.result) {
          this.$emit('accept', this.channelId)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isAction = false
      }
    },
    async onDecline() {
      this.isAction = true
      try {
        const token = cookieService.getCookie('user_token') || ''
        const profileAccount = JSON.parse(
          localStorage.getItem('profile_account') || '{}'
        )
        const login = profileAccount?.email || profileAccount?.username || ''

        const res = await apiSsoService.post('/api/channel/verify-email', {
          code: token,
          login,
          channel: this.channelId,
          decline: true
        })

        if (res && res.data && res.data.result) {
          this.$emit('decline', this.channelId)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isAction = false
      }
    }
  }
}
</script>
